'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
  ContentfulDOMHelper 

  // -----------------------------------------------------------------------------------------
  // WE ARE IN THE PROCESS OF DEPRICATING PRODUCT.JS CLASS, IN FAVOUR OF THIS CLASS 
  // If a method you need in Product.js class is not here, copy it over and modify
  // as needed (Most of this code has been copied over from Product.js with some modifications)
  // ------------------------------------------------------------------------------------------

  Handles loading ui components for templates that have Data loaded in from Contentful. (For example ActionPanel.js, GenericLayout.js)

  Parameters:
    contentRef [string] (required):
      Reference to the content model property for the product template content.

    presenter [APIPresenter] (required):
      Reference to the APIPresenter in order to communicate with SOA and create data models.

*/

function ContentfulDOMHelper(contentRef, presenter, node) {
  this._history = new History();
  this._presenter = presenter;
  this.contentRef = contentRef;
  this._analytics = new Analytics();
  this.valid = true;

  this._constructor = function () {
    this._contentModel = this._presenter.getModelProperty(this.contentRef);
    if (!this._contentModel._contentType) {
      console.warn('ContentfulDOMHelper _constructor: _contentModel is invalid.');
      this.valid = false;
    }
  };

  this.loadMedia = function (container, customConfig, contentRef, callback) {
    if (!this._contentModel[contentRef]) {
      console.warn('loadMedia: Media asset not found.');
    }

    var media = this._contentModel[contentRef];
    var contentType = media.file.contentType;


    if (contentType === undefined) {
      console.warn('loadMedia: Media asset not found.');
    } else if (contentType === 'application/json') {
      this.loadAnimation(container, media, customConfig, callback);
    } else {
      this.loadImage(container, media);
    }
  };

  this._getAnimationHTML = function () {
    return '<div class="media-item media-item__animation animation js--animation" />';
  };

  this.loadAnimation = function (container, media, customConfig, callback) {
    var _this = this;

    container.innerHTML = this._getAnimationHTML();

    var animationElement = container.querySelector('.js--animation');
    var url = media.file.url;

    var config = {
      loop: true,
      autoplay: true,
      url: url
    };
    if (customConfig) {
      _extends(config, customConfig);
    }
    var animationProps = {
      container: animationElement,
      loop: config.loop,
      autoplay: config.autoplay,
      path: config.url
    };

    if (config.preserveAspectRatio && config.preserveAspectRatio === 'none') {
      animationElement.addClass('media-item__full-screen-background');
      animationProps.rendererSettings = {
        preserveAspectRatio: 'none'
      };
    }

    if (typeof bodymovin === 'undefined') {
      $.ajax({
        url: '/member/assets/mogo-ui-lib-min/js/vendor/lottie.min.js?version=5.7.12',
        dataType: 'script',
        cache: true
      }).done(function () {
        _this.animation = bodymovin.loadAnimation(animationProps);
      });
    } else {
      this.animation = bodymovin.loadAnimation(animationProps);
    }

    // this.animation = bodymovin.loadAnimation(animationProps);

    // future functionality
    // this.animation.addEventListener('loopComplete', () => {
    //   console.log('loopComplete');
    // });

    var _ani = this.animation;
    this.animation.addEventListener('DOMLoaded', function () {
      // Callback for when we want to handle Lottie animation programatically
      // Passes the lottie animationObj back to the callback
      // at this point, animationObj is loaded completely
      if (callback) return callback();

      $(node).addClass('media-loaded');
      if (config.autoplay === false) {
        setTimeout(function () {
          _ani.play();
        }, 800);
      }
    });
  };

  this.loadImage = function (container, media) {
    var url = media.file.url,
        title = media.title;


    container.innerHTML = this._getImageHTML(url, title);
  };

  this._getImageHTML = function (url, alt) {
    return '<img class="media-item media-item__image js--image" src="' + url + '"  alt="' + alt + '" />';
  };

  this.loadHTML = function (container, content) {
    container.innerHTML = this._contentModel[content];
  };

  this.bindLinkToElement = function (elementContainer, actionId, contentfulObj) {
    var configuration = contentfulObj && contentfulObj.configuration ? contentfulObj.configuration : this._contentModel;
    if (!configuration) return console.warn('bindLinkToElement: unable to find contentful configuration');

    // TargetId should only exist when there's a path mapping (_paths: ContentfulDOMHelper.shortcutMappings)
    var targetId = this.getTargetId(configuration, actionId);
    elementContainer.setAttribute('data-content-target-id', targetId);
    elementContainer.addEventListener('click', this.gotoTarget.bind(this, targetId));

    elementContainer.classList.remove('hide');
    this._addDaiToCta(elementContainer);
  };

  /*
      getTargetId
      TargetId should only exist when there's a path mapping (_paths: Product.shortcutMappings)
  
      Params:
        configObj(obj): found in contentfulObj.configuration
        actionId(string): found in contentfulObj.configuration.navigationActions[0].id 
    */
  this.getTargetId = function (configObj, actionId) {
    var actions = 'navigationActions'; // pick a default
    var lookupId = actionId || 'nav-action-1'; // pick a default

    var navActions = configObj[actions];
    var actionConfig = navActions.find(function (item) {
      return item.id === lookupId;
    });
    var actionTarget = actionConfig.targetId;
    return actionTarget; // ex 'wealth-overview'
  };

  this._addDaiToCta = function (ctaElement) {
    var dai = 'Contentful-Contentful Navigation-' + this._contentModel.category.replace(/-/g, '=') + ' | ' + this._contentModel._contentType.sys.id.replace(/-/g, '=') + ' | ' + ctaElement.textContent.replace(/-/g, '=') + '-Navigation-Component';
    ctaElement.setAttribute('data-analytics-id', dai);
  };

  this.getSoaActionPath = function (configObj, actionId, modelPath) {
    var actions = 'navigationActions'; // pick a default
    var lookupId = actionId || 'soa-action-1'; // pick a default
    var navActions = configObj[actions];
    var actionConfig = navActions.find(function (item) {
      return item.id === lookupId;
    });
    var actionPath = modelPath ? modelPath + '.' + actionConfig.action : 'account.' + actionConfig.action;
    return this._presenter.hasAction(actionPath) ? actionPath : null;
  };

  this.gotoTarget = function (target) {
    if (Product.shortcutMappings[target]) {
      this._history.goToUrl(Product.shortcutMappings[target]);
    } else if (target.indexOf('https') > -1) {
      window.open(target);
    } else {
      console.warn('gotoTarget: shortcut not found.');
      this._history.goToUrl('/member/dashboard/home'); // don't leave the user in a jam
    }
  };

  this.pushPageViewAnalyticsEvent = function () {
    if (this._contentModel) {
      // see https://mogofintech.atlassian.net/wiki/spaces/DIG/pages/224101439/Contentful+Events
      // when a page includes a contentful piece, use the article title as the page title
      // the overview content type uses either statusTitle or headline for titles
      var articleTitle = this._contentModel.statusTitle || this._contentModel.headline;
      this._analytics.forcePushEvent('virtual-page-view', {
        Page: [decodeURI(articleTitle)]
      });
    } else {
      this._analytics.forcePushEvent('virtual-page-view');
    }
  };

  this.pushContentfulAnalyticsEvent = function () {
    this._analytics.forcePushEvent('contentful', {
      type: [this._contentModel._contentType.sys.id],
      category: [this._contentModel.category],
      content: [this._contentModel._id],
      version: [this._contentModel._updatedAt]
    });
  };

  this.destroy = function () {
    if (this.animation) {
      // this.animation.removeEventListener('loopComplete');
      this.animation.destroy();
    }
  };

  this._constructor();
}